import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updatePswRes;
export const updatePswTodo = createAsyncThunk('updatePsw', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url:  process.env.REACT_APP_API_URL + `gate_pass_update/${data?.id}`,
            data: {
                "password": data.new_psw,
                "confpassword":  data.confirm_psw    
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })
        return updatePswRes = res.data

    } catch (error) {
        return updatePswRes = error.response.data
    }
})


